
import { CityPageTemplate } from '@/components/seo/CityPageTemplate';
import { Zap, Truck, Building } from 'lucide-react';

const HoustonPage = () => {
  return (
    <CityPageTemplate
      city="Houston"
      state="Texas"
      stateAbbr="TX"
      population="2.3 million+"
      majorIndustries={["energy", "petrochemicals", "aerospace", "healthcare", "international trade"]}
      businessChallenges={[
        "Oil and gas industry cyclical employment",
        "High-risk industrial safety requirements",
        "International workforce management",
        "Hurricane and weather-related disruptions",
        "Complex petrochemical regulatory compliance"
      ]}
      peoSolutions={[
        "Energy industry specialized HR services",
        "Comprehensive safety and compliance programs",
        "International employee visa and payroll support",
        "Business continuity and disaster planning",
        "Industry-specific workers' compensation"
      ]}
      localBusinessTypes={[
        { name: "Energy", description: "Oil & gas, renewable energy, utilities" },
        { name: "Petrochemicals", description: "Refineries, chemical manufacturing" },
        { name: "Aerospace", description: "NASA contractors, aviation, space tech" },
        { name: "Healthcare", description: "Medical center, hospitals, research" }
      ]}
      metaDescription="Find the best PEOs in Houston with The PEO App. Compare quotes from top Houston Professional Employer Organizations offering specialized HR solutions for energy, petrochemical, and aerospace industries."
      keyFeatures={[
        {
          icon: Zap,
          title: "Energy Industry Expertise",
          description: "Specialized HR solutions for Houston's energy sector including cyclical staffing and safety compliance."
        },
        {
          icon: Building,
          title: "Industrial Safety Focus",
          description: "Comprehensive safety programs and workers' compensation management for high-risk industrial operations."
        },
        {
          icon: Truck,
          title: "International Trade Support",
          description: "Expert HR services for companies engaged in international trade with visa and cross-border employment support."
        }
      ]}
    />
  );
};

export default HoustonPage;
